module.exports = __webpack_public_path__ + "static/media/ImgCategoria10Curtiembre.f53e3f4c.jpg";